/** Notifications sahifasi lug'ati (en: manba). */
export default {
  title: "Notifications",
  total_one: "{{count}} total",
  total_other: "{{count}} total",
  markAll: "Mark all as read",
  marked_one: "{{count}} marked as read",
  marked_other: "{{count}} marked as read",
  nothingToMark: "Nothing to mark",
  markFailed: "Could not mark as read",
  unread: "Unread",
  loadFailed: "Could not load notifications.",
  caughtUp: "You're all caught up",
  none: "No notifications yet",
  desc: "Approvals, transfers and reminders will appear here.",
  pagination: "notifications",
};
